import config from 'config';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useAppDispatch } from 'reducer';
import { hideDrawer } from 'reducer/slices/drawerSlice';
import { hideLoading, showLoading } from 'reducer/slices/loadingSlice';
import gather from 'tools/gather';
import utils from 'tools/utils';

const History = () => {
  const dispatch = useAppDispatch();
  const [transactionList, setTransactionList] = useState([]);

  const showTransactionList = () => {
    const rows: any = [];

    transactionList.forEach((e: any, i) => {
      rows.push(
        <div className='order_show' key={i}>
          <span>
            مقدار: {utils.formatter(e.amount)} {e.coin}
          </span>
          <span>تبدیل شده: {utils.formatter(e.converted)} HotVoucher</span>
          {e.voucher && <span>ووچر: {e.voucher}</span>}
          {e.voucher1 && <span>ووچر: {e.voucher1}</span>}
          <span>سمت: {e.side}</span>
          <span>نوع: {e.type}</span>
          <span>وضعیت: {e.status}</span>
          <span>تاریخ: {moment(e.createdAt).format('YYYY-MM-DD , HH:mm:ss')}</span>
        </div>,
      );
    });

    if (rows.length === 0) {
      rows.push(
        <div key={1000000} className='empty'>
          هیچ تراکنشی وجود ندارد
        </div>,
      );
    }

    return rows;
  };

  const init = async () => {
    dispatch(showLoading());

    const r2 = await gather(`${config.apiUrl}/transaction`, true).get();
    if (r2.code === 200) {
      setTransactionList(r2.data);
    }

    dispatch(hideLoading());
  };

  useEffect(() => {
    init();
  }, []);

  return (
    <div className='popup_page contain_center'>
      <div className='back_to_main' onClick={() => dispatch(hideDrawer())}>
        <div className='back_icon'></div>
      </div>
      <h3>تراکنش ها و کدها</h3>
      <div className='form'>
        <div className='list'>{showTransactionList()}</div>
      </div>
    </div>
  );
};

export default History;
